import React from 'react'
import { BreadcrumbJsonLd } from 'next-seo'
import { isEmpty, trimEnd } from 'lodash-es'
import { joinElements } from '@loc/react-utils'

import Link from '../Link'


import { useOrigin } from '@/hooks/routes';
import { useMemo } from 'react';
import { cls } from 'tagged-classnames-free';
export interface IBreadcrumbProps {
  data?: {
    name: string
    href: string
  }[]
  style?: React.CSSProperties
  className?: string
}

export default function Breadcrumb(props: IBreadcrumbProps) {
  const { data, style, className } = props

  const [origin] = useOrigin()

  const renderData = useMemo(() => {
    if (!data || isEmpty(data)) {
      return null
    }

    return data.map((item) => {
      if (item.href.startsWith('http:') || item.href.startsWith('https:')) {
        return item
      }

      return { ...item, href: trimEnd(`${origin}${item.href}`, '/') }
    })
  }, [origin, data])

  if (!renderData) {
    return null
  }

  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={renderData.map((item, index) => {
          return {
            position: index + 1,
            name: item.name,
            item: item.href,
          }
        })}
      />
      <div
        style={style}
        className={cls`
          text-f-text | mt-3 block text-xs
          ${className}
        `}
      >
        {joinElements(
          renderData.map((item, index) => {
            if (renderData.length === index + 1) {
              return (
                <span key={item.href} className={`text-f-text-f-secondary`}>
                  {item.name}
                </span>
              )
            }
            return (
              <Link
                key={item.href}
                href={item.href}
                className='font-semibold hover:underline'
              >
                {item.name}
              </Link>
            )
          }),
          <span className='i-com--right size-3'></span>,
        )}
      </div>
    </>
  )
}
